import env from '../constants/env';

const AUTHAPI = () => {
      return 'https://stage-api.etows.app:8443';
};

export default AUTHAPI;
